import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed"
}
const _hoisted_2 = { class: "fixed md:w-1/4 sm:w-1/3 grid grid-cols-12 top-16 bottom-0 right-1/4 border-l border-gray-300 bg-white overflow-y-auto" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1" }, null, -1)
const _hoisted_4 = { class: "col-span-10" }
const _hoisted_5 = { class: "pt-5 grid grid-cols-12" }
const _hoisted_6 = { class: "text-left p-2 col-span-full" }
const _hoisted_7 = { class: "text-text-lighter text-xs" }
const _hoisted_8 = { class: "lg:text-2xl md:text-xl sm:text-base font-bold mb-5 text-text" }
const _hoisted_9 = { class: "text-text-lighter text-sm" }
const _hoisted_10 = { class: "text-text-lighter text-sm" }
const _hoisted_11 = {
  key: 0,
  class: "col-span-full"
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode("View publication")
const _hoisted_13 = { class: "col-span-1" }

import OpenDoi from '@/components/Buttons/OpenDoi.vue';
import { SearchResponse } from '@/models/Search/index';
import { XIcon } from '@heroicons/vue/solid';
import { PropType } from 'vue';


export default /*#__PURE__*/_defineComponent({
  props: {
  entity: {
    type: Object as PropType<SearchResponse | undefined>,
  },
},
  emits: ['close'],
  setup(__props) {





const authorsLong = (result: SearchResponse) => {
  let res = '';
  let authlength = result.entity.authors.length;
  for (let i = 0; i < authlength; i++) {
    res += result.entity.authors[i].name;
    if (i < authlength - 2) res += ', ';
    if (i == authlength - 2) res += ' and ';
  }
  return res;
};

const citAndRefs = (cit: number, refs: number[]) => {
  let res = '';

  // citations
  res += cit;
  if (cit == 1) res += ' Citation';
  else res += ' Citations';

  // divider
  res += ' | ';

  // references
  let refsCount = 0;
  if (refs != null) refsCount = refs.length;
  res += refsCount;
  if (refsCount == 1) res += ' Reference';
  else res += ' References';

  return res;
};

return (_ctx: any,_cache: any) => {
  return (__props.entity)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(__props.entity.entity.publisher) + " (" + _toDisplayString(__props.entity.entity.year) + ") ", 1),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("h2", null, _toDisplayString(__props.entity.entity.title), 1)
                ]),
                _createElementVNode("div", _hoisted_9, _toDisplayString(authorsLong(__props.entity)), 1),
                _createElementVNode("div", _hoisted_10, _toDisplayString(citAndRefs(__props.entity.entity.citationCount, __props.entity.entity.refs)), 1)
              ]),
              (__props.entity.entity.doi)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createVNode(OpenDoi, {
                      doi: __props.entity.entity.doi
                    }, {
                      default: _withCtx(() => [
                        _hoisted_12
                      ]),
                      _: 1
                    }, 8, ["doi"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
              class: "font-semibold rounded float-right p-3 mr-3 focus:outline-none hover:text-yellow-400"
            }, [
              _createVNode(_unref(XIcon), { class: "h-5 w-5 align-middle inline-block" })
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})